/**
 * FixOEM Chat Widget
 * Widget de chat inteligente con IA para atención al cliente
 * Version: 1.0.0
 */

(function() {
  'use strict';

  // Configuración del widget
  const defaultConfig = {
    apiEndpoint: 'https://vudtt0b1yk.execute-api.us-east-2.amazonaws.com/PRODUCTION/chatbot',
    position: 'right',
    bottomOffset: 20,
    sideOffset: 20,
    primaryColor: '#FF6B35',
    secondaryColor: '#F7931E',
    zIndex: 9999,
    welcomeMessage: '👋 Soy Fixo, te ayudare con respuestas inmediatas.',
    companyName: 'FixOEM',
    supportPhone: '2211939333',
    enableSound: false,
    autoOpen: false
  };

  // Preguntas frecuentes predefinidas
  const quickQuestions = [
    // { id: 'envios', icon: '📦', text: 'Información de envíos', question: '¿Cuál es el tiempo y costo de envío?' },
    // { id: 'garantia', icon: '🛡️', text: 'Garantía y devoluciones', question: '¿Cuál es la política de garantía?' },
    // { id: 'sucursales', icon: '🏪', text: 'Ubicación de sucursales', question: '¿Dónde están las sucursales?' },
    // { id: 'productos', icon: '🔧', text: 'Sobre nuestros productos', question: '¿Qué marcas y productos venden?' },
    // { id: 'mayoristas', icon: '📊', text: 'Precio mayoristas', question: '¿Cuál es el precio para mayoristas?' },
    // { id: 'otro', icon: '💬', text: 'Otra pregunta', question: '' }
  ];

  class FixOEMChatWidget {
    constructor(config) {
      this.config = { ...defaultConfig, ...config };
      this.isOpen = false;
      this.conversationId = this.generateId();
      this.messages = [];
      this.isTyping = false;
      this.init();
    }

    generateId() {
      return `chat_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }

    init() {
      this.injectStyles();
      this.createWidget();
      this.attachEventListeners();
      
      if (this.config.autoOpen) {
        setTimeout(() => this.toggleChat(), 2000);
      }
    }

    injectStyles() {
      const styles = `
        .fixoem-chat-widget * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        .fixoem-chat-widget {
          position: fixed;
          bottom: ${this.config.bottomOffset}px;
          ${this.config.position}: ${this.config.sideOffset}px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          z-index: ${this.config.zIndex};
        }

        .fixoem-toggle-btn {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: linear-gradient(135deg, ${this.config.primaryColor} 0%, ${this.config.secondaryColor} 100%);
          border: none;
          color: white;
          font-size: 14px;
          cursor: pointer;
          box-shadow: 0 4px 12px #16BE45;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .fixoem-toggle-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 16px #16BE45;
        }

        .fixoem-toggle-btn.pulse {
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%, 100% { box-shadow: 0 4px 12px #16BE45); }
          50% { box-shadow: 0 4px 20px #16BE45; }
        }

        .fixoem-notification-badge {
          position: absolute;
          top: -5px;
          right: -5px;
          background: #16BE45;
          color: white;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: bold;
        }

        .fixoem-chat-container {
          position: absolute;
          bottom: 0;
          ${this.config.position}: 0;
          width: 300px;
          height: 300px;
          background: white;
          border-radius: 16px;
          box-shadow: 0 5px 40px rgba(0, 0, 0, 0.16);
          display: flex;
          flex-direction: column;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px) scale(0.95);
          transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }

        .fixoem-chat-container.active {
          opacity: 1;
          visibility: visible;
          transform: translateY(0) scale(1);
        }

        .fixoem-chat-header {
          background: linear-gradient(135deg, ${this.config.primaryColor} 0%, ${this.config.secondaryColor} 100%);
          color: white;
          padding: 10px;
          border-radius: 16px 16px 0 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .fixoem-chat-header h3 {
          font-size: 14px;
          font-weight: 600;
        }

        .fixoem-chat-header p {
          font-size: 12px;
          opacity: 0.9;
          margin-top: 2px;
        }

        .fixoem-close-btn {
          background: none;
          border: none;
          color: white;
          font-size: 14px;
          cursor: pointer;
          padding: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: background 0.2s;
        }

        .fixoem-close-btn:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        .fixoem-chat-content {
          flex: 1;
          overflow-y: auto;
          padding: 20px;
          display: flex;
          flex-direction: column;
          background: #f9f9f9;
        }

        .fixoem-chat-messages {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
#
        .fixoem-message {
          display: flex;
          gap: 8px;
          animation: slideIn 0.3s ease;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .fixoem-message.user {
          justify-content: flex-end;
        }

        .fixoem-message-bubble {
          max-width: 75%;
          padding: 12px 16px;
          border-radius: 16px;
          font-size: 14px;
          line-height: 1.5;
          word-wrap: break-word;
        }

        .fixoem-message.bot .fixoem-message-bubble {
          background: white;
          color: #333;
          border-bottom-left-radius: 4px;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }

        .fixoem-message.user .fixoem-message-bubble {
          background: ${this.config.primaryColor};
          color: white;
          border-bottom-right-radius: 4px;
        }

        .fixoem-quick-options {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 16px;
          padding: 0 20px;
        }

        .fixoem-option-btn {
          background: white;
          border: 1px solid #e0e0e0;
          padding: 12px 14px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 13px;
          text-align: left;
          transition: all 0.2s ease;
          color: #333;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .fixoem-option-btn:hover {
          background: ${this.config.primaryColor};
          color: white;
          border-color: ${this.config.primaryColor};
          transform: translateX(4px);
        }

        .fixoem-agent-btn {
          background: linear-gradient(135deg, ${this.config.primaryColor} 0%, ${this.config.secondaryColor} 100%);
          color: white;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          width: calc(100% - 40px);
          margin: 0 auto;
          transition: all 0.2s ease;
        }

        .fixoem-agent-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
        }

        .fixoem-chat-input-area {
          padding: 15px 20px;
          border-top: 1px solid #e0e0e0;
          display: flex;
          gap: 10px;
          background: white;
          border-radius: 0 0 16px 16px;
        }

        .fixoem-chat-input {
          flex: 1;
          border: 1px solid #e0e0e0;
          border-radius: 20px;
          padding: 10px 16px;
          font-size: 14px;
          font-family: inherit;
          transition: border-color 0.2s;
        }

        .fixoem-chat-input:focus {
          outline: none;
          border-color: ${this.config.primaryColor};
          box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.1);
        }

        .fixoem-send-btn {
          background: ${this.config.primaryColor};
          border: none;
          color: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }

        .fixoem-send-btn:hover:not(:disabled) {
          background: ${this.config.secondaryColor};
          transform: scale(1.05);
        }

        .fixoem-send-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .fixoem-typing-indicator {
          display: flex;
          gap: 4px;
          padding: 12px 16px;
          background: white;
          border-radius: 16px;
          width: fit-content;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }

        .fixoem-typing-dot {
          width: 8px;
          height: 8px;
          background: #999;
          border-radius: 50%;
          animation: typing 1.4s infinite;
        }

        .fixoem-typing-dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .fixoem-typing-dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes typing {
          0%, 60%, 100% {
            transform: translateY(0);
          }
          30% {
            transform: translateY(-10px);
          }
        }

        @media (max-width: 480px) {
          .fixoem-chat-container {
            width: calc(100vw - 20px);
            height: calc(100vh - 100px);
            max-height: 600px;
            bottom: 70px;
          }
        }

        .fixoem-chat-container {
          position: absolute;
          bottom: 0;
          ${this.config.position}: 0;
          width: 300px;
          height: 450px; /* Aumenta la altura para acomodar el botón */
          background: white;
          border-radius: 16px;
          box-shadow: 0 5px 40px rgba(0, 0, 0, 0.16);
          display: flex;
          flex-direction: column;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px) scale(0.95);
          transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }

        .fixoem-agent-btn {
          background: linear-gradient(135deg, ${this.config.primaryColor} 0%, ${this.config.secondaryColor} 100%);
          color: white;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          width: 100%; /* Cambia a 100% */
          margin: 0; /* Elimina el margin auto */
          transition: all 0.2s ease;
          text-align: center;
          text-decoration: none;
          display: block; /* Asegura que se comporte como bloque */
        }

        .fixoem-agent-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
        }

        /* Agrega un contenedor para el botón de WhatsApp */
        .fixoem-whatsapp-container {
          padding: 5px 20px;
          background: white;
          border-radius: 0 0 16px 16px;
        }

        .fixoem-chat-input-area {
          padding: 5px 20px;
          border-top: 1px solid #e0e0e0;
          display: flex;
          gap: 10px;
          background: white;
          border-radius: 0; /* Quita el border-radius de aquí */
        }
      `;

      const styleSheet = document.createElement('style');
      styleSheet.textContent = styles;
      document.head.appendChild(styleSheet);
    }

    createWidget() {
      const pagePath = window.location.pathname;
      const widget = document.createElement('div');
      widget.className = 'fixoem-chat-widget';
      widget.innerHTML = `
        <button class="fixoem-toggle-btn pulse" id="fixoemToggleBtn">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-whatsapp" viewBox="0 0 16 16">
            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
          </svg>
        </button>
        
        <div class="fixoem-chat-container" id="fixoemChatContainer">
          <div class="fixoem-chat-header">
            <div>
              <!--<h3>${this.config.companyName}</h3>-->
              <p>Atención Inmediata con IA</p>
            </div>
            <button class="fixoem-close-btn" id="fixoemCloseBtn">✕</button>
          </div>
          
          <div class="fixoem-chat-content">
            <div class="fixoem-chat-messages" id="fixoemChatMessages"></div>
          </div>

          <div class="fixoem-quick-options" id="fixoemQuickOptions"></div>
          
          <div class="fixoem-chat-input-area">
            <input 
              type="text" 
              class="fixoem-chat-input" 
              id="fixoemChatInput" 
              placeholder="Pregunta, con respuesta inmediata"
            >
            <button class="fixoem-send-btn" id="fixoemSendBtn">→</button>
          </div>
          <div class="fixoem-whatsapp-container">
            <a href="https://wa.me/2211939333?text=Hola,%20me%20puedes%20apoyar%20*fixoem.com${pagePath}*" class="fixoem-agent-btn" id="fixoemAgentBtn">
              No te dimos la respuesta correcta? Habla con un Humano!
            </a>
          </div>
        </div>
      `;

      document.body.appendChild(widget);
      this.renderQuickOptions();
      this.addWelcomeMessage();
    }

    renderQuickOptions() {
      const container = document.getElementById('fixoemQuickOptions');
      container.innerHTML = quickQuestions.map(q => `
        <button class="fixoem-option-btn" data-question-id="${q.id}">
          <span>${q.icon}</span>
          <span>${q.text}</span>
        </button>
      `).join('');
    }

    attachEventListeners() {
      const toggleBtn = document.getElementById('fixoemToggleBtn');
      const closeBtn = document.getElementById('fixoemCloseBtn');
      const sendBtn = document.getElementById('fixoemSendBtn');
      const input = document.getElementById('fixoemChatInput');
      const agentBtn = document.getElementById('fixoemAgentBtn');
      const optionBtns = document.querySelectorAll('.fixoem-option-btn');

      toggleBtn.addEventListener('click', () => this.toggleChat());
      closeBtn.addEventListener('click', () => this.toggleChat());
      sendBtn.addEventListener('click', () => this.sendMessage());
      input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') this.sendMessage();
      });
      agentBtn.addEventListener('click', () => this.contactAgent());
      
      optionBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const questionId = e.currentTarget.dataset.questionId;
          this.handleQuickQuestion(questionId);
        });
      });
    }

    toggleChat() {
      this.isOpen = !this.isOpen;
      const container = document.getElementById('fixoemChatContainer');
      const toggleBtn = document.getElementById('fixoemToggleBtn');
      
      if (this.isOpen) {
        container.classList.add('active');
        toggleBtn.classList.remove('pulse');
        toggleBtn.style.display = 'none';
        document.getElementById('fixoemChatInput').focus();
      } else {
        toggleBtn.style.display = 'block';
        container.classList.remove('active');
      }
    }

    addWelcomeMessage() {
      this.addMessage(this.config.welcomeMessage, 'bot');
    }

    addMessage(content, role) {
      const messagesContainer = document.getElementById('fixoemChatMessages');
      const messageDiv = document.createElement('div');
      messageDiv.className = `fixoem-message ${role}`;
      messageDiv.innerHTML = `
        <div class="fixoem-message-bubble">${content}</div>
      `;
      messagesContainer.appendChild(messageDiv);
      messagesContainer.scrollTop = messagesContainer.scrollHeight;

      this.messages.push({ role, content, timestamp: Date.now() });
    }

    showTypingIndicator() {
      const messagesContainer = document.getElementById('fixoemChatMessages');
      const typingDiv = document.createElement('div');
      typingDiv.className = 'fixoem-message bot';
      typingDiv.id = 'fixoemTypingIndicator';
      typingDiv.innerHTML = `
        <div class="fixoem-typing-indicator">
          <div class="fixoem-typing-dot"></div>
          <div class="fixoem-typing-dot"></div>
          <div class="fixoem-typing-dot"></div>
        </div>
      `;
      messagesContainer.appendChild(typingDiv);
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }

    removeTypingIndicator() {
      const indicator = document.getElementById('fixoemTypingIndicator');
      if (indicator) indicator.remove();
    }

    async sendMessage() {
      const input = document.getElementById('fixoemChatInput');
      const message = input.value.trim();
      
      if (!message || this.isTyping) return;

      this.addMessage(message, 'user');
      input.value = '';
      
      document.getElementById('fixoemQuickOptions').style.display = 'none';
      
      await this.getAIResponse(message);
    }

    async getAIResponse(userMessage) {
      this.isTyping = true;
      this.showTypingIndicator();

      try {
        const response = await fetch(this.config.apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "question": userMessage
          })
        });

        if (!response.ok) throw new Error('Error en la respuesta del servidor');

        const data = await response.json();
        this.removeTypingIndicator();
        this.addMessage(data.answer || data.message, 'bot');
        
      } catch (error) {
        console.error('Error al obtener respuesta:', error);
        this.removeTypingIndicator();
        this.addMessage(
          'Disculpa, tengo problemas para conectarme. ¿Prefieres hablar con un asesor al ' + 
          this.config.supportPhone + '?',
          'bot'
        );
      } finally {
        this.isTyping = false;
      }
    }

    handleQuickQuestion(questionId) {
      const question = quickQuestions.find(q => q.id === questionId);
      if (!question) return;

      if (question.question) {
        document.getElementById('fixoemChatInput').value = question.question;
        this.sendMessage();
      } else {
        document.getElementById('fixoemQuickOptions').style.display = 'none';
        document.getElementById('fixoemChatInput').focus();
      }
    }

    contactAgent() {
      this.addMessage('Me gustaría hablar con un asesor', 'user');
      document.getElementById('fixoemQuickOptions').style.display = 'none';
      
      this.addMessage(
        `Perfecto, un asesor te atenderá pronto. Puedes contactarnos también al <strong>${this.config.supportPhone}</strong> o visitar cualquiera de nuestras sucursales.`,
        'bot'
      );
    }
  }

  // Función de inicialización global
  window.initFixOEMChat = function(customConfig = {}) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        new FixOEMChatWidget(customConfig);
      });
    } else {
      new FixOEMChatWidget(customConfig);
    }
  };

  // Auto-inicialización con configuración desde ventana
  if (window.fixoemChatConfig) {
    window.initFixOEMChat(window.fixoemChatConfig);
  }
})();